import React from 'react'
import t from 'prop-types'
import cx from 'classnames'
import Image from '../../Images/Image'

// The Info Card is a grouping of related information that does not link to other content.

const ImageWrapper = ({ link, children }) => {
  if (link) {
    return (
      <a href={link} target="_blank" rel="noreferer">
        {children}
      </a>
    )
  }

  return <div className="foo">{children}</div>
}

const CardInfoImageMap = {
  true: {
    component(image, logoHasLeftBorder, link) {
      return (
        <div className="bg-blue-100 rounded-xl p-3 w-16 h-16 flex justify-center items-center">
          <ImageWrapper link={link}>
            <Image className="block w-full h-auto" {...image} />
          </ImageWrapper>
        </div>
      )
    },
  },
  false: {
    component(image, logoHasLeftBorder, isImageFullWidth, link) {
      const classes = `block ${logoHasLeftBorder ? 'pl-4' : 'mb-4'}
        ${isImageFullWidth ? 'w-full h-auto' : 'w-auto h-12'}`
      const LogoImage = (
        <ImageWrapper link={link}>
          <Image className={classes} {...image} />
        </ImageWrapper>
      )

      if (logoHasLeftBorder) {
        return (
          <div
            className="border-5 border-blue-200 h-57 mb-4 flex items-center pr-2"
            style={{
              'border-right': 'none',
              'border-bottom': 'none',
              'border-top': 'none',
            }}
          >
            {LogoImage}
          </div>
        )
      }

      return LogoImage
    },
  },
}

const CardInfo = ({
  heading,
  image,
  hasBg,
  link,
  isImageFullWidth,
  isOnDarkBg,
  subheading,
  logoHasLeftBorder,
}) => {
  const CardInfoImage = CardInfoImageMap[hasBg]

  return (
    <div>
      {CardInfoImage.component(
        image,
        logoHasLeftBorder,
        isImageFullWidth,
        link
      )}
      {heading && (
        <h3
          className={cx(
            'mt-6 text-lg md:text-xl lg:text-2xl leading-tight font-serif font-bold',
            {
              'text-gray-700': !isOnDarkBg,
              'text-white': isOnDarkBg,
            }
          )}
        >
          {heading}
        </h3>
      )}
      {subheading && (
        <p
          className={cx('mt-3 text-base leading-normal font-sans font-normal', {
            'text-gray-600': !isOnDarkBg,
            'text-white': isOnDarkBg,
          })}
        >
          {subheading}
        </p>
      )}
    </div>
  )
}

CardInfo.propTypes = {
  hasBg: t.bool,
  heading: t.string,
  image: t.object,
  isOnDarkBg: t.bool,
  isImageFullWidth: t.bool,
  subheading: t.string,
  logoHasLeftBorder: t.bool,
}

CardInfo.defaultProps = {
  hasBg: false,
  logoHasLeftBorder: false,
}

export default CardInfo
